export default __webpack_public_path__ + "static/media/XS4 One Plus.da0b1142.jpg";